import { render, staticRenderFns } from "./debtorManagement.vue?vue&type=template&id=a8f3f1a4&"
import script from "./debtorManagement.vue?vue&type=script&lang=js&"
export * from "./debtorManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports